import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle';
import Icon from '@veeva/corgix/icon';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import {
    filterLogicAddButtonCSS,
    filterLogicErrorTextAreaCSS,
    filterLogicLabelCSS,
    filterLogicStringCSS,
    filterLogicTextAreaContainerCSS,
    filterLogicTextAreaCSS,
    removeFilterLogicButtonContainerCSS,
} from './styles/FilterLogicButton.styles';

export default function FilterLogicButton({
    addFilterLogic,
    setAddFilterLogic,
    pendingFilterQuery,
    setPendingFilterQuery,
    setPendingCreateCustomFilterQuery,
    pendingFilterList,
    error,
    setErrorMsg,
    selectedCustomerFilterList,
}) {
    const filterLogicTextRef = useRef(null);
    const [filterQueryContent, setFilterQueryContent] = useState('');

    const handleAddLogic = () => {
        setAddFilterLogic(true);
    };
    const handleTextChange = (e) => {
        const newValue = e.target.value;
        setFilterQueryContent(newValue);

        if (filterLogicTextRef?.current) {
            clearTimeout(filterLogicTextRef.current);
        }

        if (newValue === '') {
            setPendingFilterQuery('');
            setFilterQueryContent('');
            setErrorMsg('');
            if (selectedCustomerFilterList === 'create_custom') {
                setPendingCreateCustomFilterQuery('');
            }
        } else {
            filterLogicTextRef.current = setTimeout(() => {
                if (selectedCustomerFilterList === 'create_custom') {
                    setPendingCreateCustomFilterQuery(newValue);
                }
                setPendingFilterQuery(newValue);
                setFilterQueryContent('');
            }, 200);
        }
    };
    const handleRemoveLogic = () => {
        setAddFilterLogic(false);
        const newFilterQuery = pendingFilterList.map((item, index) => `${index + 1}`).join(' AND ');
        setPendingCreateCustomFilterQuery(newFilterQuery);
        setPendingFilterQuery(newFilterQuery);
        setErrorMsg('');
    };
    return (
        <div>
            {addFilterLogic ? (
                <div>
                    <div css={filterLogicLabelCSS}> Filter Logic </div>
                    <div css={removeFilterLogicButtonContainerCSS}>
                        <button
                            type="button"
                            onClick={handleRemoveLogic}
                            css={filterLogicAddButtonCSS}
                        >
                            Remove
                        </button>
                    </div>
                    <div css={filterLogicTextAreaContainerCSS}>
                        <textarea
                            type="text"
                            id="editFilterQuery"
                            value={filterQueryContent || pendingFilterQuery}
                            onChange={handleTextChange}
                            css={error ? filterLogicErrorTextAreaCSS : filterLogicTextAreaCSS}
                        />
                    </div>
                </div>
            ) : (
                <button type="button" onClick={handleAddLogic} css={filterLogicAddButtonCSS}>
                    <Icon size="xs" type={faPlusCircle} />
                    <div css={filterLogicStringCSS}>Add Filter Logic</div>
                </button>
            )}
        </div>
    );
}
FilterLogicButton.propTypes = {
    addFilterLogic: PropTypes.bool,
    error: PropTypes.bool,
    pendingFilterList: PropTypes.arrayOf(
        PropTypes.shape({
            appKeys: PropTypes.arrayOf(PropTypes.string),
            customerIds: PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            ),
            customerSizes: PropTypes.arrayOf(PropTypes.string),
            industries: PropTypes.arrayOf(PropTypes.string),
            podNames: PropTypes.arrayOf(PropTypes.string),
            regions: PropTypes.arrayOf(PropTypes.string),
            segments: PropTypes.arrayOf(PropTypes.string),
            vaultBasics: PropTypes.string,
            vaultSizes: PropTypes.arrayOf(PropTypes.string),
        }),
    ),
    pendingFilterQuery: PropTypes.string,
    selectedCustomerFilterList: PropTypes.string,
    setAddFilterLogic: PropTypes.func,
    setErrorMsg: PropTypes.func,
    setPendingCreateCustomFilterQuery: PropTypes.func,
    setPendingFilterQuery: PropTypes.func,
};
